import { FlatList, Header, PageContainer, Text, YStack } from '@frontend/web-react';
import { ScheduledTaskCard } from '@frontend/web/components';
import { useListRecurrencesQuery } from '@frontend/web/hooks';
import { createFileRoute, useRouter } from '@tanstack/react-router';

const Recurrence = () => {
  const router = useRouter();
  const { data: recurrences, isLoading: isRecurrencesLoading } = useListRecurrencesQuery();
  return (
    <PageContainer
      HeaderComponent={<Header isLoading={isRecurrencesLoading} onClickBack={router.history.back} title="" />}
      isLoading={isRecurrencesLoading}
      isScrollable
      padding="none"
    >
      <YStack className="gap-sm px-md">
        <Text type="h4">Looking ahead</Text>
        <FlatList
          contentContainerClassName="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
          data={recurrences}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => <ScheduledTaskCard recurrence={item} />}
        />
      </YStack>
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/recurrence/')({
  component: Recurrence,
});
